var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Consents = (function (Consents) {

        Consents.Messages = (function (Messages) {
            
            Messages.InsertAllCookiesSuccess = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Consents.Messages.InsertAllCookiesSuccess');
            };
            Messages.InsertAllCookiesSuccess.className = 'Vendd.Consents.Messages.InsertAllCookiesSuccess';


            Messages.InsertConsents = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Consents.Messages.InsertConsents');
            };
            Messages.InsertConsents.className = 'Vendd.Consents.Messages.InsertConsents';
            
            return Messages;

        })(Consents.Messages || {});

        return Consents;

    })(Vendd.Consents || {});


    return Vendd;

})(Vendd || {});